import { render, staticRenderFns } from "./AddTagDialog.vue?vue&type=template&id=b13707f0&scoped=true&"
import script from "./AddTagDialog.vue?vue&type=script&lang=js&"
export * from "./AddTagDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddTagDialog.vue?vue&type=style&index=0&id=b13707f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13707f0",
  null
  
)

export default component.exports